import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { BreakpointsOfTOrT, theme } from '../../../theme';
import { ContentCardBase } from './ContentCardBase';
import { ContentCardBody } from './ContentCardBody';
import { ContentCardLower } from './ContentCardLower';
import { ContentCardTitle } from './ContentCardTitle';
import { ContentCardUpper } from './ContentCardUpper';

type ContentCardSize = 'small' | 'large';

export type StyledContentCardProps = {
  size: BreakpointsOfTOrT<ContentCardSize>;
};

const ContentCardIconContainer = styled.div`
  padding: ${theme.spacings[1].rem};
`;

export type ContentCardProps = StyledContentCardProps & {
  icon: React.ReactNode;
  body: string;
  title: string;
  className?: string;
};

const ContentCardUnstyled: React.FC<PropsWithChildren<ContentCardProps>> = ({
  children,
  body,
  icon,
  title,
  size,
  className,
}) => (
  <ContentCardBase size={size} className={className}>
    <ContentCardUpper cardSize={size}>
      <ContentCardIconContainer>{icon}</ContentCardIconContainer>
      <ContentCardTitle cardSize={size} size={5}>
        {title}
      </ContentCardTitle>
      <ContentCardBody cardSize={size}>{body}</ContentCardBody>
    </ContentCardUpper>
    <ContentCardLower cardSize={size}>{children}</ContentCardLower>
  </ContentCardBase>
);

export const ContentCard = styled(ContentCardUnstyled)``;
